var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [_vm._v(_vm._s(_vm.$t("ContinuousReport.TabInfo.Quarterly")))]),
    _vm._v(" "),
    _c("h3", [
      _vm._v(_vm._s(_vm.$t("ContinuousReport.Collaboration.Volunteers.Title")))
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t("ContinuousReport.Collaboration.Volunteers.HasVolunteers")
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "ContinuousReport.Collaboration.Volunteers.HasVolunteers_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("ContinuousReport.Collaboration.Volunteers.Count")))
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t("ContinuousReport.Collaboration.Volunteers.TargetsRelated")
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "ContinuousReport.Collaboration.Volunteers.TargetsRelated_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t(
            "ContinuousReport.Collaboration.Volunteers.TargetGroupsRelated"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "ContinuousReport.Collaboration.Volunteers.TargetGroupsRelated_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("h3", [
      _vm._v(_vm._s(_vm.$t("ContinuousReport.Collaboration.Partners.Title")))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t("ContinuousReport.Collaboration.Partners.Title_Instructions")
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(_vm.$t("ContinuousReport.Collaboration.Partners.HasPartners"))
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("ContinuousReport.Collaboration.Partners.Partner")))
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _c("b", [_vm._v(_vm._s(_vm.$t("Enums.PartnerTypeOptions.2")))])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [_vm._v(_vm._s(_vm.$t("Enums.PartnerTypeOptions.3")))]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-0" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "SummaryReport.Collaboration.Partners.CongregationName_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [_vm._v(_vm._s(_vm.$t("Enums.PartnerTypeOptions.5")))])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [_vm._v(_vm._s(_vm.$t("Enums.PartnerTypeOptions.6")))])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [_vm._v(_vm._s(_vm.$t("Enums.PartnerTypeOptions.1")))])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [_vm._v(_vm._s(_vm.$t("Enums.PartnerTypeOptions.7")))])
      ])
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(_vm.$t("SummaryReport.Collaboration.Partners.CooperationTypes"))
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "SummaryReport.Collaboration.Partners.CooperationTypes_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(_vm.$t("ContinuousReport.Collaboration.Partners.TargetsRelated"))
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "ContinuousReport.Collaboration.Partners.TargetsRelated_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t("ContinuousReport.Collaboration.Partners.TargetGroupsRelated")
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "ContinuousReport.Collaboration.Partners.TargetGroupsRelated_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t(
            "ContinuousReport.Collaboration.Partners.RedirectedCustomersWereCounted"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t(
            "ContinuousReport.Collaboration.Partners.RedirectedCustomersToPartner"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t(
            "ContinuousReport.Collaboration.Partners.RedirectedCustomersFromPartner"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("ContinuousReport.Notes.Collaboration")))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(_vm.$t("ContinuousReport.Notes.Collaboration_Instructions"))
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }